import { valueWritable } from "./valueStore";

type FetchStoreOptions<T> = {
    initialValue: T;
    errorValue: T;
    onError?: (error: unknown) => T | undefined;
    validate?: (data: unknown) => T | undefined;
}

export function fetchStore<T>(url: string, options: FetchStoreOptions<T>) {
    const store = valueWritable<T>(options.initialValue);
    const status = valueWritable<"loading" | "error" | "success">("loading");

    async function getData() {
        status.set("loading");
        try {
            const response = await fetch(url);
            let data = await response.json();
            data = options.validate?.(data) ?? data;
            store.set(data);

            status.set("success");
        } catch (error) {
            const res = options.onError?.(error);
            store.set(res ?? options.errorValue);

            status.set("error");
        }
    }

    getData();

    return {
        subscribe: store.subscribe,
        get value() {
            return store.value;
        },

        reFetch: getData,

        status: {
            subscribe: status.subscribe,
        }
    };
}
